// extracted by mini-css-extract-plugin
export default {"search-button":"SearchButton___style-module__search-button___6QiFj"};